import { render, staticRenderFns } from "./AppCoinInput.vue?vue&type=template&id=6a0ff07d&scoped=true"
import script from "./AppCoinInput.vue?vue&type=script&lang=js"
export * from "./AppCoinInput.vue?vue&type=script&lang=js"
import style0 from "./AppCoinInput.vue?vue&type=style&index=0&id=6a0ff07d&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0ff07d",
  null
  
)

export default component.exports